import React from "react";
import { Button, Col, Collapse, FormGroup, Label, Row, Input } from "reactstrap";
import { DocumentUpload } from "../helpers/DocumentUpload";
import { NumericCardBox } from "../helpers/NumericCardBox";
import { CargaEditModel, EstadoCargaItem, ExcelTemplateGetMessage, LicenciaContenidosEditModel, ResultadosCargaLicenciasExcelExport, TipoAccesoLicencia, TipoCarga, TipoLicencia } from "../models/dataModels";
import { AlertsService } from "../utils/AlertsService";
import { ComponentBase } from "../utils/base/ComponentBase";
import { I18n } from "../utils/I18n";
import { CancelIcon, DownloadIcon, FileIcon } from "../utils/Icons";
import { Loading } from "../utils/Loading";
import { CargaFicherosService } from "./CargaFicherosService";
import nameof from "ts-nameof.macro";
import { TipoLicenciaDropDown } from "../helpers/EnumDropDown";


interface LicenciasUsuariosState {
    showLoading: boolean;
    previewItem: LicenciaContenidosEditModel;
    numItemsRead: number;
    fileUrl: string;
    cargaId?: number | null;
    numRowsOk?: number | null;
    numRowsError?: number | null;
    numRowsDuplicated?: number | null;
    ficheroSeleccionado: boolean;
    tipoLicencia: TipoLicencia;
    actualizarSiExiste: boolean;
    crearEstructuraColegio: boolean;
    noImportarCredenciales: boolean;
    mostrarTiposAcceso: boolean;
    mensajeGlobal?: string | null;

}

export class LicenciasUsuarios extends ComponentBase<any, LicenciasUsuariosState> {

    public constructor(props: any) {
        super(props);

        this.state = {
            previewItem: null,
            showLoading: false,
            numItemsRead: 0,
            fileUrl: null,
            ficheroSeleccionado: false,
            tipoLicencia: TipoLicencia.Tiendas,
            actualizarSiExiste: false,
            crearEstructuraColegio: false,
            noImportarCredenciales: false,
            mostrarTiposAcceso: false,
            mensajeGlobal: null
        };
    }

    protected _getTemplate() {

        this.setState({ showLoading: true },
            () => {
                var service = new CargaFicherosService();
                var model = {
                    tipoCarga: TipoCarga.Licencia
                } as ExcelTemplateGetMessage;
                service.getTemplate(model)
                    .then(() => this.setState({ showLoading: false }))
            });
    }

    protected _uploadFile() {
        this.setState({ showLoading: true },
            () => {
                var service = new CargaFicherosService();
                var model = {
                    fileUrl: this.state.fileUrl,
                    tipoCarga: TipoCarga.Licencia,
                    tipoLicencia: this.state.tipoLicencia,
                    actualizarSiExiste: this.state.actualizarSiExiste,
                    crearEstructuraColegio: this.state.crearEstructuraColegio,
                    noImportarCredenciales: this.state.crearEstructuraColegio && this.state.noImportarCredenciales,
                } as CargaEditModel;
                service.cargarExcel(model)
                    .then((data) => {
                        var state = this._cloneStateForSetState();
                        state.showLoading = false;
                        state.numRowsOk = data.numRowsOk;
                        state.numRowsError = data.numRowsError;
                        state.numRowsDuplicated = data.numRowsDuplicated;
                        state.cargaId = data.cargaId;
                        state.mensajeGlobal = data.mensajeGlobal;
                        state.previewItem = null;

                        this.setState(state);
                    })
                    .catch((error) => {
                        this.setState({ showLoading: false }, () => AlertsService.showError(error));
                    });
            });
    }

    protected _downloadResultsExcel(estado: EstadoCargaItem) {
        this.setState({ showLoading: true },
            () => {
                var service = new CargaFicherosService();
                var msg = {
                    cargaId: this.state.cargaId,
                    estadoCarga: estado,
                    tipoCarga: TipoCarga.Licencia
                } as ResultadosCargaLicenciasExcelExport;

                service.descargarResultadosCargaLicencias(msg)
                    .then(() => this.setState({ showLoading: false }))
            });
    }

    protected _renderResult(): JSX.Element {
        return <React.Fragment>

            {this.state.mensajeGlobal && <Row className="mb-2">
                <Col md={12}>
                    <div className={"alert alert-warning"}>{this.state.mensajeGlobal}</div>
                </Col>
            </Row>}

            <Row className="mb-4">
                <Col md={3}>
                    <NumericCardBox
                        numberValue={this.state.numRowsOk + this.state.numRowsError + this.state.numRowsDuplicated}
                        headerText={I18n.Strings.cargaFicheros.numRowsTotal} />
                </Col>
                <Col md={3}
                    className={"pointer"}
                    onClick={() => {
                        if (this.state.numRowsOk > 0) {
                            this._downloadResultsExcel(EstadoCargaItem.Correcto);
                        }
                    }}
                >
                    <NumericCardBox
                        icono={this.state.numRowsOk > 0 ? <DownloadIcon /> : null}
                        numberValue={this.state.numRowsOk}
                        headerText={I18n.Strings.cargaFicheros.numRowsOk} />
                </Col>
                <Col md={3}
                    className={"pointer"}
                    onClick={() => {
                        if (this.state.numRowsDuplicated > 0) {
                            this._downloadResultsExcel(EstadoCargaItem.Duplicado);
                        }
                    }}
                >
                    <NumericCardBox
                        icono={this.state.numRowsDuplicated > 0 ? <DownloadIcon /> : null}
                        numberValue={this.state.numRowsDuplicated}
                        headerText={I18n.Strings.cargaFicheros.numRowsDuplicated} />
                </Col>
                <Col md={3}
                    className={"pointer"}
                    onClick={() => {
                        if (this.state.numRowsError > 0) {
                            this._downloadResultsExcel(EstadoCargaItem.Erroneo);
                        }
                    }}
                >
                    <NumericCardBox
                        icono={this.state.numRowsError > 0 ? <DownloadIcon /> : null}
                        numberValue={this.state.numRowsError}
                        headerText={I18n.Strings.cargaFicheros.numRowsError} />
                </Col>
            </Row>
            <Row>
                <Col md={12} className={"text-center"}>
                    <Button className={"btn-rounded btn"} id="save" color="primary" onClick={() => {
                        var state = this._cloneStateForSetState();
                        state.numItemsRead = 0;
                        state.previewItem = null;
                        state.cargaId = null;
                        state.numRowsOk = 0;
                        state.numRowsError = 0;
                        state.numRowsDuplicated = 0;
                        state.ficheroSeleccionado = false;
                        this.setState(state);
                    }}>
                        <FileIcon />
                        {I18n.Strings.cargaFicheros.cargarOtroFichero}
                    </Button>
                </Col>
            </Row>
        </React.Fragment>
    }

    /**
     * Lista de referencia con los valores que admite la columna "Tipo de acceso" del Excel.
     * Se genera a partir del enum TipoAccesoLicencia, así que no se desincroniza del servidor.
     */
    protected _renderTiposAccesoValidos(): JSX.Element {

        var valores = Object.keys(TipoAccesoLicencia)
            .map((clave) => TipoAccesoLicencia[clave as keyof typeof TipoAccesoLicencia]);

        return <React.Fragment>
            <div className={"text-end"}>
                <Button
                    className={"btn-link p-0"}
                    color="link"
                    id={nameof(this.state.mostrarTiposAcceso)}
                    onClick={() => {
                        var state = this._cloneStateForSetState();
                        state.mostrarTiposAcceso = !state.mostrarTiposAcceso;
                        this.setState(state);
                    }}>
                    {I18n.Strings.cargaFicheros.tiposAccesoValidos}
                </Button>
            </div>
            <Collapse isOpen={this.state.mostrarTiposAcceso}>
                <p className={"mt-2 mb-1"}>
                    {I18n.Strings.cargaFicheros.tiposAccesoValidosAyuda}
                </p>
                <table className="table table-sm table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>{I18n.Strings.cargaFicheros.tiposAccesoValidosValor}</th>
                            <th>{I18n.Strings.cargaFicheros.tiposAccesoValidosDescripcion}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {valores.map((valor) => <tr key={valor}>
                            <td><code>{valor}</code></td>
                            <td>{I18n.Strings.getEnumText(`TipoAccesoLicencia.${valor}`)}</td>
                        </tr>)}
                    </tbody>
                </table>
            </Collapse>
        </React.Fragment>
    }

    protected _renderPreviewItem(): JSX.Element {
        if (this.state.previewItem == null) {
            return <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Label>Se han leído 0 registros.</Label>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className={"text-center"}>
                        <Button className={"btn-rounded btn"} id="save" color="primary" onClick={() => {
                            var state = this._cloneStateForSetState();
                            state.numItemsRead = 0;
                            state.previewItem = null;
                            state.cargaId = null;
                            state.numRowsOk = 0;
                            state.numRowsError = 0;
                            state.numRowsDuplicated = 0;
                            state.ficheroSeleccionado = false;
                            this.setState(state);
                        }}>
                            <FileIcon />
                            {I18n.Strings.cargaFicheros.cargarOtroFichero}
                        </Button>
                    </Col>
                </Row>
            </React.Fragment>
        }
        else {
            return <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Label>Se han leído {this.state.numItemsRead} registros:</Label>
                    </Col>
                </Row>
                <Row className="tit-lista-lic">
                    <Col md={3}>
                        {I18n.Strings.colegioUsuarios.login}
                    </Col>
                    <Col md={2}>
                        {I18n.Strings.colegioUsuarios.grupoClase}
                    </Col>
                    <Col md={2}>
                        {I18n.Strings.contenidos.isbn}
                    </Col>
                    <Col md={2}>
                        {I18n.Strings.licenciasContenido.tipoAcceso}
                    </Col>
                    <Col md={3}>
                        {I18n.Strings.licenciasContenido.credenciales}
                    </Col>
                </Row>
                <Row className="datos-lic">
                    <Col md={3}>
                        {this.state.previewItem.usuario}
                    </Col>
                    <Col md={2}>
                        {this.state.previewItem.clase}
                    </Col>
                    <Col md={2}>
                        {this.state.previewItem.isbn}
                    </Col>
                    <Col md={2}>
                        {this.state.previewItem.tipoAcceso}
                    </Col>
                    <Col md={3}>
                        {this.state.previewItem.credenciales}
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className={"text-center"}>
                        <Button className={"btn-rounded btn"} id="save" color="primary" onClick={() => {
                            this._uploadFile();
                        }}>
                            <FileIcon />
                            {I18n.Strings.cargaFicheros.cargarFichero}
                        </Button>
                        <Button className={"btn-rounded btn"} id="save" color="secondary" onClick={() => {
                            var state = this._cloneStateForSetState();
                            state.numItemsRead = 0;
                            state.previewItem = null;
                            state.ficheroSeleccionado = false;
                            this.setState(state);
                        }}>
                            <CancelIcon />
                            {I18n.Strings.cancel}
                        </Button>
                    </Col>
                </Row>
            </React.Fragment>
        }
    }

    render() {
        return <React.Fragment>
            {this.state.showLoading && <Loading />}
            <Row className={"align-items-center"}>
                <Col md={6}>
                    <p className={"mb-0"}>Carga de ficheros de licencias de usuario</p>
                </Col>
                <Col md={6} className={"text-end"}>
                    <Button className={"btn-rounded btn"} id="save" color="primary" onClick={() => {
                        this._getTemplate();
                    }}>
                        <FileIcon />
                        {I18n.Strings.cargaFicheros.descargarPlantilla}
                    </Button>
                </Col>
                <Col md={12}>
                    {this._renderTiposAccesoValidos()}
                </Col>
                <Col md={12}>
                    <FormGroup>

                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.actualizarSiExiste = evt.target.checked;
                                this.setState(state);
                            }}
                            type="checkbox"
                            style={{ padding: 0, marginRight: 10 }}
                            name={nameof(this.state.actualizarSiExiste)}
                            id={nameof(this.state.actualizarSiExiste)}
                            checked={this.state.actualizarSiExiste || false}
                        />
                        <Label for={nameof(this.state.actualizarSiExiste)}>Actualizar licencias si existen</Label>
                    </FormGroup>
                </Col>
                <Col md={12}>
                    <FormGroup>

                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.crearEstructuraColegio = evt.target.checked;
                                if (!state.crearEstructuraColegio) {
                                    state.noImportarCredenciales = false;
                                }
                                this.setState(state);
                            }}
                            type="checkbox"
                            style={{ padding: 0, marginRight: 10 }}
                            name={nameof(this.state.crearEstructuraColegio)}
                            id={nameof(this.state.crearEstructuraColegio)}
                            checked={this.state.crearEstructuraColegio || false}
                        />
                        {I18n.Strings.cargaFicheros.crearEstructuraColegioAyuda}
                    </FormGroup>
                </Col>
                {this.state.crearEstructuraColegio && <Col md={12}>
                    <FormGroup>

                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.noImportarCredenciales = evt.target.checked;
                                this.setState(state);
                            }}
                            type="checkbox"
                            style={{ padding: 0, marginRight: 10 }}
                            name={nameof(this.state.noImportarCredenciales)}
                            id={nameof(this.state.noImportarCredenciales)}
                            checked={this.state.noImportarCredenciales || false}
                        />
                        {I18n.Strings.cargaFicheros.noImportarCredencialesAyuda}
                    </FormGroup>
                </Col>}
                <Col md={12}>
                    <FormGroup>
                        <Label for={nameof(this.state.tipoLicencia)}>
                            {I18n.Strings.cargaFicheros.tipoLicencia}
                        </Label>
                        <TipoLicenciaDropDown
                            label={null}
                            id={nameof(this.state.tipoLicencia)}
                            value={this.state.tipoLicencia}
                            required={true}
                            errorMessage={null}
                            onChanged={(value: string) => {
                                var state = this._cloneStateForSetState();
                                state.tipoLicencia = value == "" ? null : value as TipoLicencia;
                                this.setState(state);
                            }}
                        />
                    </FormGroup>
                </Col>

                <div className={"carga-ficheros"}>
                    {!this.state.ficheroSeleccionado && this.state.cargaId == null && <Col md={12}>
                        <Label>{I18n.Strings.cargaFicheros.subirFicheroEtiqueta}</Label>
                        <DocumentUpload
                            manualUpload={false}
                            style={{ fontSize: 14, overflow: "ellipsis" }}
                            title={I18n.Strings.cargaFicheros.subirFichero}
                            formatosAceptados={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                            zoneStyle={{ margin: 0, padding: 10 }}
                            uploadUrl={`intranet/cargaFichero/analizarExcel`}
                            tipoCarga={TipoCarga.Licencia}
                            multiple={false}
                            onUpload={(data) => {
                                if (data != null) {
                                    var state = this._cloneStateForSetState();
                                    if (data.previewItem != null) {
                                        var item = data.previewItem as LicenciaContenidosEditModel;
                                        state.previewItem = item;
                                    }
                                    state.ficheroSeleccionado = true;
                                    state.numItemsRead = data.numItemsRead;
                                    state.fileUrl = data.documentUrl;
                                    this.setState(state);
                                }
                            }}
                        />
                    </Col>}
                    {this.state.ficheroSeleccionado && this.state.cargaId == null && <Col md={12}>
                        {this._renderPreviewItem()}
                    </Col>}
                    {this.state.ficheroSeleccionado && this.state.cargaId != null && <Col md={12}>
                        {this._renderResult()}
                    </Col>}
                </div>
            </Row>
        </React.Fragment>
    };
}